import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchQuery = '', onSearchChange = () => {}, onSearch = () => {} }) => {
  const [localQuery, setLocalQuery] = useState(searchQuery || '');

  useEffect(() => {
    setLocalQuery(searchQuery || '');
  }, [searchQuery]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  const handleInputChange = (e) => {
    const query = e.target.value;
    setLocalQuery(query);
    onSearchChange(query);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col sm:flex-row items-center gap-3">
        <div className="relative flex-1 w-full">
          <Icon
            name="Search"
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <Input
            type="search"
            placeholder="Search location, keywords, or address"
            value={localQuery}
            onChange={handleInputChange}
            className="pl-10 pr-4 h-12 w-full"
            aria-label="Property Search"
          />
        </div>

        <div className="w-full sm:w-auto">
          <Button type="submit" variant="default" size="md" className="w-full sm:w-auto px-6 py-3">
            Search
          </Button>
        </div>
      </div>
    </form>
  );
};

export default SearchBar;
